import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts'
import { ApexOptions } from 'apexcharts';
import classes from './HomeChart.module.css'


interface IHomeChartProps{
    title?: string,
    series?: [{
      id: string,
      title: string,
      data: number[]
    }] | [],
    dates?: string[] | []
}

const HomeChart: React.FC<IHomeChartProps> = (props)=>{
  const [series, setSeries] = useState<ApexAxisChartSeries>([])
  useEffect(()=>{
    if(props.series){
      let newData = props.series.map(s=>({
        name: s.title,
        data: s.data
      }))
      setSeries(newData)
    }

  },[props.series])
/*   const  series: ApexAxisChartSeries = [
    {
      name: "مهندس كهرباء",
      data: [4000, 4254, 7254, 20254, 3854, 5254, 1200],
    },
    {
      name: "أمين مخازن",
      data: [3500, 5700, 3000, 18000, 4700, 1800, 2007],
    },
    {
      name: "محامي",
      data: [7200, 4000, 2500, 17000, 8000, 6500, 8000],
    }
  ] */
  const options: ApexOptions = {
    chart: {
      height: 350,
      type: 'line',
      zoom: {
        enabled: false
      },
      fontFamily: 'Cairo-Regular',
      foreColor: '#BBBBBB'
    },
    legend: {
        fontFamily: 'Cairo-Regular',
        showForSingleSeries: true
    },
    dataLabels: {
      enabled: false,
      style: {
          fontFamily: 'Cairo-Regular',
      }
    },
    stroke: {
      curve: 'smooth',
    },
    colors: ["#33ff5b", "#ff5733", "#00bdff"],
    xaxis: {
      categories: props.dates,
      labels: {
          style: {
              colors: '#bbb'
          }
      },
      
    }
  }
    return (
        <React.Fragment>
            <p className={classes.chartTitle}>{props.title}</p>
            <div id="chart">
                <Chart options={options} series={series} type="line" height={350} />
            </div>
        </React.Fragment>
    )
}

export default HomeChart